/* Hand-drawn heading marker-line / circle -- opt-in only.
   Nothing gets a line/circle unless it explicitly has [data-hand-drawn]
   (set by the hand-drawn-heading snippet when a word is chosen).

   The overlay is appended to <body> and uses position:fixed (not absolute),
   positioned purely from getBoundingClientRect() -- this guarantees it can
   never expand the page's scrollable height, no matter how it's sized, and
   it also can't get clipped by an ancestor's overflow:hidden (common on
   slideshow/carousel text wrappers). */
(function () {
  var HAND_DRAWN_SELECTOR = '[data-hand-drawn]';

  // Underline/strike are drawn in a 0-300 x 0-20 box and stretched to fit any width.
  var UNDERLINE_PATH =
  'M6,14 C90,9 210,9 294,14';
  var STRIKE_PATH =
    'M2,10 C60,4 140,16 200,9 C240,5 270,13 298,9';

  // Circle is drawn in a 0-200 x 0-120 box, with a slight self-overlap at the
  // top-right so it reads as a real pen stroke rather than a perfect oval.
  var CIRCLE_PATH =
  'M38,62 ' +
  'C58,18 142,0 186,16 ' +
  'C222,30 236,72 214,98 ' +
  'C188,124 110,126 56,104 ' +
  'C10,86 4,44 42,26 ' +
  'C74,10 110,8 132,16 ' +
  'C144,20 150,26 142,30';

  // All active overlays, so we can reposition every one of them together
  // on a single scroll/resize listener instead of one listener per overlay.
  var registry = [];

  function buildSvg(style, color, weight) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'hand-drawn-line hand-drawn-line--' + style);
    svg.setAttribute('viewBox', style === 'circle' ? '0 0 200 120' : '0 0 300 20');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.position = 'fixed';
    svg.style.pointerEvents = 'none';
    svg.style.zIndex = '9999';
    svg.style.overflow = 'visible';

    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    var d = UNDERLINE_PATH;
    if (style === 'strike') d = STRIKE_PATH;
    if (style === 'circle') d = CIRCLE_PATH;
    path.setAttribute('d', d);
    path.style.fill = 'none';
    path.style.stroke = color;
    path.style.strokeWidth = weight;
    path.style.strokeLinecap = 'round';
    path.style.strokeLinejoin = 'round';
    svg.appendChild(path);

    return { svg: svg, path: path };
  }

  // Walks up ALL ancestors (to <body>) to detect if the target is actually
  // hidden right now -- e.g. an inactive fade-carousel slide (opacity
  // crossfade, all slides stacked at the same position) or a display:none/
  // visibility:hidden ancestor. No depth limit: carousel libraries like Slick
  // often wrap slides in extra layers (.slick-slide, .slick-track, etc.) that
  // can sit many levels above the actual heading/span being circled.
  function isTargetHidden(target) {
    var el = target;
    while (el && el !== document.documentElement) {
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return true;
      if (parseFloat(cs.opacity) <= 0.05) return true;
      el = el.parentElement;
    }
    return false;
  }

  // Computes and applies the overlay's on-screen position/size from the
  // target's current bounding box. Viewport-relative (for position:fixed) --
  // no scroll offsets involved, so it can never inflate page scroll height.
  function positionSvg(svg, target, style) {
    if (isTargetHidden(target)) {
      svg.style.display = 'none';
      return;
    }

    var rect = target.getBoundingClientRect();
    if (!rect.width || !rect.height) {
      svg.style.display = 'none';
      return; // target still hidden (e.g. inactive slide)
    }

    svg.style.display = '';

    var left, top, width, height;

    if (style === 'circle') {
      // Padding is how far the circle extends beyond the text, as a % of the
      // text's own width/height. Smaller numbers = tighter/smaller circle.
      var padXPct = parseFloat(target.getAttribute('data-hand-drawn-pad-x'));
      var padYPct = parseFloat(target.getAttribute('data-hand-drawn-pad-y'));
      if (isNaN(padXPct)) padXPct = 18;
      if (isNaN(padYPct)) padYPct = 35;

      var padX = rect.width * (padXPct / 100);
      var padY = rect.height * (padYPct / 100);
      width = rect.width + padX * 2;
      height = rect.height + padY * 2;
      left = rect.left - padX;
      top = rect.top - padY;
    } else {
      var padX2 = rect.width * 0.02;
      width = rect.width + padX2 * 2;
      height = Math.max(rect.height * 0.35, 10);
      left = rect.left - padX2;
      top =
        style === 'strike'
          ? rect.top + rect.height / 2 - height / 2
          : rect.top + rect.height - height * 0.4; // underline
    }

    svg.style.left = left + 'px';
    svg.style.top = top + 'px';
    svg.style.width = width + 'px';
    svg.style.height = height + 'px';
  }

  function repositionAll() {
    registry.forEach(function (entry) {
      positionSvg(entry.svg, entry.target, entry.style);
    });
  }

  // Single shared, rAF-throttled scroll/resize listener for all overlays.
  var scrollTicking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        repositionAll();
        scrollTicking = false;
      });
    },
    { passive: true }
  );
  window.addEventListener('resize', repositionAll);

  // Fade-transition carousels (like this theme's slideshow) change which slide
  // is visible purely via an opacity crossfade -- no scroll or resize event
  // fires when that happens. This lightweight interval catches that case so
  // an overlay never gets stuck showing on top of the wrong slide.
  requestAnimationFrame(function update() {
    repositionAll();
    requestAnimationFrame(update);
});

  function whenScrollTriggerReady(callback) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      callback();
    } else {
      setTimeout(function () {
        whenScrollTriggerReady(callback);
      }, 100);
    }
  }

  function initHandDrawnLines(root) {
    whenScrollTriggerReady(function () {
      gsap.registerPlugin(ScrollTrigger);

      var scope = root && root.querySelectorAll ? root : document;
      var elements = scope.querySelectorAll(HAND_DRAWN_SELECTOR);

      elements.forEach(function (target) {
        if (target.dataset.handDrawnInit) return;
        if (!target.textContent.trim()) return;

        target.dataset.handDrawnInit = 'true';

        var style = target.getAttribute('data-hand-drawn') || 'circle';
        var color = target.getAttribute('data-hand-drawn-color') || '#c0392b';
        var weight =
          target.getAttribute('data-hand-drawn-weight') || (style === 'circle' ? '9' : '7');

        var built = buildSvg(style, color, weight);
        document.body.appendChild(built.svg);

        registry.push({ svg: built.svg, target: target, style: style });

        function reposition() {
          positionSvg(built.svg, target, style);
        }
        reposition();

        // Recompute on this element's own size changes -- covers fonts loading,
        // responsive breakpoints, and carousels revealing a previously-hidden slide.
        if (window.ResizeObserver) {
          new ResizeObserver(reposition).observe(target);
        }
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(reposition);
        }

        var length = built.path.getTotalLength();
        gsap.set(built.path, { strokeDasharray: length, strokeDashoffset: length });

        gsap.set(built.path, {
  strokeDasharray: length,
  strokeDashoffset: length
});

ScrollTrigger.create({
          trigger: target,
          start: 'top 85%',
          onEnter: function () {
            reposition(); // make sure position is current right before it draws in
            gsap.to(built.path, {
              strokeDashoffset: 0,
              duration: 1,
              ease: 'power2.out'
            });
          }
        });
      });

      ScrollTrigger.refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHandDrawnLines();
    });
  } else {
    initHandDrawnLines();
  }

  // Re-run for sections added/edited live in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initHandDrawnLines(event.target);
  });

  // Expose so other scripts (ajax cart, quick view, etc.) can re-run it on new content.
  window.initHandDrawnLines = initHandDrawnLines;
})();